import {COURSE_ACCESS_TYPE_DAYS, COURSE_ACCESS_TYPE_END_DATE, COURSE_HISTORY_ACTION_NAMES} from "../constants";
import {centsToDollarStrWSign} from "../utils/usacmUtils";
import {getCourseCart} from "../api/CourseApi";

/**
 * Reloads the number of lines in the user's cart (kept in the context so the menu can hide an empty cart)
 */
export function loadCourseCartCount(setCourseCartCount) {
  getCourseCart((status, data) => {
    if (status === 200) {
      setCourseCartCount(data.items.length);
    }
  });
}

/**
 * A course price's amount as the buyer sees it - "Free" for 0
 */
export function getCoursePriceAmountStr(cents) {
  return cents ? centsToDollarStrWSign(cents) : 'Free';
}

/**
 * How long the access bought at a course price lasts, as the buyer sees it
 */
export function getCoursePriceAccessStr(coursePrice) {
  if (coursePrice?.course_access_type === COURSE_ACCESS_TYPE_DAYS) {
    return `${coursePrice.access_days} days of access`;
  }
  if (coursePrice?.course_access_type === COURSE_ACCESS_TYPE_END_DATE) {
    return `Access until ${coursePrice.access_end_date}`;
  }
  return 'Lifetime access';
}

/**
 * A free price which needs no review is enrolled in straight away, every other price goes in the cart.
 * Matches courses_utils.is_free_enroll_price()
 */
export function isFreeEnrollPrice(coursePrice) {
  return !!coursePrice && !coursePrice.amount && !coursePrice.requires_review;
}

/**
 * The display name of a COURSE_HISTORY_ACTION_*
 */
export function getCourseHistoryActionDisplay(historyAction) {
  if (!historyAction) {
    return '';
  }
  return COURSE_HISTORY_ACTION_NAMES[historyAction] || historyAction;
}
